import React, { useState } from "react"
import { connect } from "react-redux"
import images from "themes/images"
import { MainActions, AuthActions } from "redux-store/models"
import { baseUrlImg } from "../../../../config/api"
import TopUpAndPayOutForm from "./TopUpAndPayOutForm"
import MasterCardForm from "./MasterCardForm"
import PrintTicket from "../../../../shared-components/ModulePopUp/PrintTicket"
import ModulePopUpBack from "../../../../shared-components/ModulePopUp/ModulePopUpBack"

const AirCashForm = ({ service, checkAircashBarcode, getAircash }) => {
  switch (service.service_id) {
    case "Aircash001":
      return <TopUpAndPayOutForm {...{ service, checkAircashBarcode, getAircash }} />
    case "Aircash Mastercard001":
      return <MasterCardForm {...{ service }} />
    default:
      return null
  }
}

const ModulePopUp = ({
  togglePopUp,
  setServiceS,
  setCompanyServices,
  setRechargeMobile,
  rechargeMobile,
  service,
  checkAircashBarcode,
  getAircash,
}) => {
  const [flipped, setFLipped] = useState(false)

  return (
    <div
      className="modulePopUP modulePopUP1 telRechanrge"
      onClick={() => {
        togglePopUp(false)
        setServiceS([])
        setCompanyServices([])
        setRechargeMobile({})
      }}
    >
      <div className="flip-container">
        <div className={`flipper ${flipped ? "flipped" : ""}`}>
          <div className="front">
            <div
              className="gift-card-redeem-container aircash"
              onClick={(e) => e.stopPropagation()}
              style={{ borderColor: service.colorBg }}
            >
              <div className="Logo">
                <div className="Logo--Help">
                  <img src={`${baseUrlImg}/${service.icon}`} alt="MrPay-LOGO" />
                </div>
              </div>

              <div className="Close">
                <span
                  className="CloseButton"
                  onClick={() => {
                    togglePopUp(false)
                    setServiceS([])
                    setCompanyServices([])
                    setRechargeMobile({})
                  }}
                >
                  <img src={images.close} alt="Chiudi" />
                </span>
              </div>
              <div className="info-icon">
                <span onClick={() => setFLipped(!flipped)}>
                  <i className="fal fa-question-circle"></i>
                </span>
              </div>

              {rechargeMobile?.error || rechargeMobile?.message ? (
                <div className="messages">
                  <div className="closeM" onClick={() => setRechargeMobile({})}>
                    Chiudi messaggi
                  </div>
                  {rechargeMobile?.error ? (
                    <div className="errorM">
                      <i className="fad fa-exclamation text-danger"></i>
                      {rechargeMobile?.error}
                    </div>
                  ) : (
                    <div className="infoM">
                      <i className="fad fa-info text-info"></i>
                      {rechargeMobile?.message}
                    </div>
                  )}
                </div>
              ) : null}

              <div className="Banner">
                <div className="banner-img">
                  <img
                    src={`${baseUrlImg}/${service.background}`}
                    alt={`${service.name}-LOGO`}
                  />
                </div>
              </div>

              <AirCashForm {...{ service, checkAircashBarcode, getAircash }} />
            </div>
          </div>

          {flipped && service && (
            <div className="back">
              <ModulePopUpBack
                service_s={service}
                handleFlip={() => setFLipped(!flipped)}
                hasPhoneNumber={true}
                showNumPadCost={false}
              />
            </div>
          )}
        </div>
      </div>

      {rechargeMobile && rechargeMobile?.receipt && (
        <PrintTicket arr={rechargeMobile} />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  accountInfo: state.auth.accountInfo,
  rechargeMobile: state.auth.rechargeMobile,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  ModulePopUp
)
